import React from 'react'
import { Button } from '@mui/material'
import type { ButtonProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import type { SxProps, Theme } from '@mui/material/styles'
import {
  getKiotListToolbarErrorOutlineButtonSx,
  getKiotListToolbarPrimaryOutlineButtonSx,
  kiotListToolbarContainedButtonSx,
  kiotListToolbarNeutralOutlineButtonSx,
  kiotToolbarButtonStartIconSx,
} from './listToolbarStyles'

const outlineIconSx: SxProps<Theme> = {
  '& .MuiButton-startIcon svg': { fontSize: 20 },
  '& .MuiButton-endIcon svg': { fontSize: 22 },
}

const outlineEndIconSpacingSx: SxProps<Theme> = {
  '& .MuiButton-endIcon': { ml: 0.25, mr: -0.35 },
}

const mergeOutlineSx = (
  base: SxProps<Theme>,
  endIcon: ButtonProps['endIcon'],
  extra?: SxProps<Theme>,
): SxProps<Theme> =>
  [base, kiotToolbarButtonStartIconSx, outlineIconSx, ...(endIcon ? [outlineEndIconSpacingSx] : []), ...(extra ? [extra] : [])] as SxProps<Theme>

/** Nút viền primary — Thêm mới, Tạo nhanh (theo chủ đề). */
export const ListToolbarPrimaryButton = ({
  children,
  sx,
  startIcon,
  endIcon,
  ...rest
}: ButtonProps) => {
  const theme = useTheme()
  return (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      disableElevation
      startIcon={startIcon}
      endIcon={endIcon}
      sx={mergeOutlineSx(getKiotListToolbarPrimaryOutlineButtonSx(theme), endIcon, sx)}
      {...rest}
    >
      {children}
    </Button>
  )
}

/** Nút viền xám — Nhập, Xuất, v.v.; `color="error"` → viền + icon đỏ. */
export const ListToolbarNeutralButton = ({
  children,
  sx,
  startIcon,
  endIcon,
  color,
  ...rest
}: ButtonProps) => {
  const theme = useTheme()
  const baseSx =
    color === 'error'
      ? getKiotListToolbarErrorOutlineButtonSx(theme)
      : kiotListToolbarNeutralOutlineButtonSx
  return (
    <Button
      variant="outlined"
      size="small"
      disableElevation
      color={color}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={mergeOutlineSx(baseSx, endIcon, sx)}
      {...rest}
    >
      {children}
    </Button>
  )
}

export type ListToolbarIconButtonProps = ButtonProps & {
  children: React.ReactNode
}

/** Nút icon contained primary — chọn cột bảng. */
export const ListToolbarIconButton = ({ children, sx, ...rest }: ListToolbarIconButtonProps) => (
  <Button
    type="button"
    variant="contained"
    color="primary"
    size="small"
    disableElevation
    sx={
      [
        kiotListToolbarContainedButtonSx,
        { minWidth: 40, width: 40, px: 0.5, flexShrink: 0 },
        sx,
      ] as SxProps<Theme>
    }
    {...rest}
  >
    {children}
  </Button>
)
